import {TFunction} from 'react-i18next';

const getMonthName = (t: TFunction<string>, index: number) =>
    t(`months.${index}`);

export default getMonthName;
